import { useKeyboardShortcut } from '@databases/react';
import { defaultStoreUtils } from '@databases/redux';
import { selectSelectedValuesCount } from '@databases/redux/cellSelections/selectors';
import { doClearValues } from '@databases/redux/contextual-menu/actions';
import { useCallback } from 'react';

import { getExperimentValue } from '@canvas/client-feature-flags';

import { CLEAR_SHORTCUT } from '../shortcuts';

interface ClearValuesKeyboardShortcutProps {
  contentId: string;
  canEditContent: boolean;
}

const useClearValuesKeyboardShortcut = ({
  contentId,
  canEditContent,
}: ClearValuesKeyboardShortcutProps) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const selectedValuesCount = defaultStoreUtils.useSelector((state) =>
    selectSelectedValuesCount(state, { contentId })
  );

  const isSelectionsPerformanceEnabled = getExperimentValue(
    'databasesSelectionsPerformance',
    'isEnabled',
    { fireExperimentExposure: false }
  );

  const handleClearValues = useCallback(() => {
    if (canEditContent) {
      dispatch(doClearValues(contentId));
    }
  }, [canEditContent, contentId, dispatch]);

  const shouldRegister = !isSelectionsPerformanceEnabled && selectedValuesCount > 1;

  useKeyboardShortcut(shouldRegister ? CLEAR_SHORTCUT : undefined, () =>
    handleClearValues()
  );
};

export default useClearValuesKeyboardShortcut;
